import React, { useState, useEffect, useRef } from 'react';
import tunnelPattern from '../assets/images/tunnel.png';

function Tunnel() {
    let dv = 0;
    let du = 0;
    const mapTbl = [];
    const stepU = 1;
    const stepV = 1;

    const scrSizeX = 64;
    const scrSizeY = 48;
    const zoom = 2.5;
    const zoomX = zoom * Math.trunc(256 / scrSizeX);
    const zoomY = zoom * Math.trunc(192 / scrSizeY);

    const textureImageRef = useRef(null);
    const tunnelCanvasRef = useRef(null);
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        if (!imageLoaded) return;
        const img = textureImageRef.current;
        const canvas = tunnelCanvasRef.current;
        canvas.width = scrSizeX;
        canvas.height = scrSizeY;
        canvas.style.transform = `scale(${zoomX}, ${zoomY})`;
        const ctx = canvas.getContext('2d');

        function getImageData(imgEl) {
            let canvas = document.createElement('canvas');
            canvas.width = imgEl.width;
            canvas.height = imgEl.height;
            let ctx = canvas.getContext('2d');
            ctx.drawImage(imgEl, 0, 0);
            return ctx.getImageData(0, 0, imgEl.width, imgEl.height).data;
        }

        function normalizeCoord(coord, maxCoord) {
            while (coord < 0) {
                coord += maxCoord;
            }
            while (coord >= maxCoord) {
                coord -= maxCoord;
            }
            return coord;
        }

        const imgData = getImageData(img);
        const maxV = img.height * 1;
        const palSet = new Set();

        for (let y = 0; y < scrSizeY; y++) {
            mapTbl[y] = [];
            const yy = y - scrSizeY / 2;
            for (let x = 0; x < scrSizeX; x++) {
                const xx = x - scrSizeX / 2;
                const u = Math.sqrt(xx * xx + yy * yy) || 1;
                mapTbl[y][x] = {
                    u: normalizeCoord(Math.round(128 * 3 / u), img.width),
                    v: normalizeCoord(Math.round(maxV * Math.atan2(yy, xx) / (Math.PI * 2)), img.height)
                };

                const addr = 4 * (y * img.width + x);
                const color = imgData[addr];
                palSet.add(color);
            }
        }

        const palMap = [...palSet].sort().reduce((o, color, index) => {
            o[color] = index;
            return o;
        }, {});

        const palFillStyle = [
            '#000073',
            '#00009D',
            '#7300CA',
            '#9D00FE',
            '#FE00FE',
            '#FE9D00',
            '#FEFE00',
            '#FEFEFE',
        ];

        function renderFrame() {
            ctx.fillStyle = 'rgb(255, 240, 240)';
            ctx.fillRect(0, 0, img.width, img.height);

            du = normalizeCoord(du + stepU, img.width);
            dv = normalizeCoord(dv + stepV, img.height);

            for (let y = 0; y < scrSizeY; y++) {
                for (let x = 0; x < scrSizeX; x++) {
                    const { u, v } = mapTbl[y][x];
                    const vv = normalizeCoord(dv + v, img.height);
                    const uu = normalizeCoord(du + u, img.width);

                    const addr = 4 * (vv * img.width + uu);
                    const color = imgData[addr];

                    const palColor = palFillStyle[palMap[color]];
                    ctx.fillStyle = typeof palColor === 'undefined' ? `rgb(${color * 0.1}, ${color * 0.2}, ${color * 0.99})` : palColor;
                    ctx.fillRect(x, y, 1, 1);
                }
            }
        }

        const interval = setInterval(renderFrame, 1000 / 10);
        return () => clearInterval(interval);
    }, [imageLoaded]);

    const onLoad = () => {
        setImageLoaded(true);
    }

    return (
        <div className="tunnel">
            <h1 className="tunnel__title">Life will change soon ...</h1>
            <div className="tunnel__container">
                <img onLoad={onLoad} ref={textureImageRef} src={tunnelPattern} className="tunnel__pattern"></img>
                <canvas ref={tunnelCanvasRef} className="tunnel__canvas"></canvas>
            </div>
        </div>
    );
}

export default Tunnel;